import { render, staticRenderFns } from "./Dialog_TemplateUpdateEmployeePower.vue?vue&type=template&id=24977866&scoped=true&"
import script from "./Dialog_TemplateUpdateEmployeePower.vue?vue&type=script&lang=js&"
export * from "./Dialog_TemplateUpdateEmployeePower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24977866",
  null
  
)

export default component.exports